export class PaymentPostingFilter{
    tenant_id: string;
    is_bill_matched: string;

    constructor(tenantId: string, is_bill_matched: string){
        this.tenant_id = tenantId;
        this.is_bill_matched = is_bill_matched;
    }
}